import {
  InputGroup,
  Select as ChakraSelect,
  InputLeftAddon,
  InputRightAddon,
  Text,
  Flex,
} from '@chakra-ui/react'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'

const Select = ({ name, label, ...rest }, ref) => {
  return (
    <>
      <InputGroup>
        <InputLeftAddon
          children={label}
          w={rest.labelWidth}
          textTransform="uppercase"
          fontSize="14px"
          color="#1D1D1D"
          borderColor={rest.error ? 'red.500' : '#C5CED6'}
        />
        <Controller
          name={name}
          control={rest.control}
          render={({ field }) => (
            <ChakraSelect
              placeholder={rest.placeholder}
              name={name}
              type={rest.type}
              borderLeftRadius={0}
              borderColor={rest.error ? '#E53E3E' : '#378BBF'}
              fontSize="14px"
              ref={ref}
              {...field}
              onChange={(e) => {
                field.onChange(e)
                rest.onChange && rest.onChange(e)
              }}
            >
              <option value="" disabled hidden>
                {rest.placeholder}
              </option>

              {rest?.options?.map((option) => (
                <option key={option.name} value={option.value}>
                  {option.name}
                </option>
              ))}
            </ChakraSelect>
          )}
        />
        {rest.rightAddon && <InputRightAddon children={rest.rightAddon} />}
      </InputGroup>
      {/* {rest.error && (
        <Text fontSize="12px" color="#E53E3E" 

        >
          {rest.error}
        </Text>
      )} */}
    </>
  )
}

export default forwardRef(Select)
